<div class="adaptive-grow-1">
    <div class="fluent-container">
        <br />
        <div class="title-color">
            <h1>EDITAR PERSONA</h1>
            <div class="title-lists">
                {{ selectedOutsider?.identificationCode }} -
                {{ selectedOutsider?.name }}
                {{ selectedOutsider?.lastName }}
            </div>
        </div>
        <div class="form-body">
            <form [formGroup]="editOutsiderForm" (ngSubmit)="updateOutsider()">
                <div class="line column-md-12">
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <app-search-select [label]="'Número de identificación'"
                            [placeholder]="'Número de identificación'" (itemSeleccionado)="fillFields($event)"
                            [searchFn]="searchPerson" [displayFnFn]="showPerson" [identifierFn]="personIdentifier"
                            formControlName="identificationCode">
                        </app-search-select>
                    </div>
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Tipo de identificación</mat-label>
                            <mat-select matInput placeholder="Ingrese el documento"
                                formControlName="identificationType">
                                <mat-option *ngFor="let i of identificationTypes" [value]="i.value">{{ i.label
                                    }}</mat-option>
                            </mat-select>
                            <mat-error class="for-text text-danger" *ngIf="
                                    editOutsiderForm
                                        .get('identificationType')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Nombres</mat-label>
                            <input matInput placeholder="Nombres" formControlName="name"
                                oninput="this.value = this.value.toUpperCase()" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editOutsiderForm
                                        .get('name')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Apellidos</mat-label>
                            <input matInput placeholder="Apellidos" formControlName="lastName"
                                oninput="this.value = this.value.toUpperCase()" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editOutsiderForm
                                        .get('lastName')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Fecha de nacimiento</mat-label>
                            <input matInput [matDatepicker]="birthDatepicker" placeholder="Fecha de nacimiento"
                                formControlName="birthDate" placeholder="dd/mm/aaaa" />
                            <mat-datepicker-toggle matSuffix [for]="birthDatepicker"></mat-datepicker-toggle>
                            <mat-datepicker #birthDatepicker></mat-datepicker>
                            <mat-error class="for-text text-danger" *ngIf="
                                    editOutsiderForm
                                        .get('birthDate')
                                        ?.hasError('required')
                                ">
                                Campo obligatorioo
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-6 column-lg-6 column-sm-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Edad</mat-label>
                            <input type="number" matInput placeholder="Edad" formControlName="age" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editOutsiderForm
                                        .get('age')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <app-search-select [label]="'Lugar de nacimiento'" [placeholder]="'Lugar de nacimineto'"
                            [preloadedList]="locations" [displayFnFn]="displayFn" [identifierFn]="idFn"
                            formControlName="placeBirth">
                        </app-search-select>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <app-search-select [label]="'Municipio de residencia'" [placeholder]="'Municipio de residencia'"
                            [preloadedList]="locations" [displayFnFn]="displayFn" [identifierFn]="idFn"
                            formControlName="location">
                        </app-search-select>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Género</mat-label>
                            <mat-select matInput placeholder="Género" formControlName="sex">
                                <mat-option *ngFor="let i of sex" [value]="i.value">{{
                                    i.label
                                    }}</mat-option>
                            </mat-select>
                            <mat-error class="for-text text-danger" *ngIf="
                                                        editOutsiderForm
                                                            .get('sex')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Teléfono</mat-label>
                            <input matInput type="number" placeholder="Teléfono" formControlName="phone" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editOutsiderForm
                                        .get('phone')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Email</mat-label>
                            <input matInput placeholder="Email" formControlName="email"
                                oninput="this.value = this.value.toUpperCase()" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editOutsiderForm
                                        .get('email')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                            <mat-error class="for-text text-danger" *ngIf="
                                    editOutsiderForm
                                        .get('email')
                                        ?.hasError('pattern')
                                ">
                                Ingrese un correo valido
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <button type="submit" class="primary-button" id="guardar">
                    <span class="button-content"><mat-icon>save</mat-icon>Guardar</span>
                </button>
                <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
                    <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
                </button>
            </form>
        </div>
    </div>
</div>
